export { default } from './CurrencyIcon'
